import React, { ReactElement } from 'react'
import { Link } from 'react-router'

import { t } from '../../utils/translation-utils'
import Button from '../elements/button'
import Card from '../elements/card'
import { Col, Row } from '../elements/grid'
import Subtitle from '../elements/Subtitle'
import Title from '../elements/Title'

export default function MinRefusion(): ReactElement | null {
  return (
    <div>
      <Card className="card-minrefusion">
        <Title>{t('basic_integrations.min_refusion.title')}</Title>
        <p>{t('basic_integrations.min_refusion.text.line_1')}</p>
        <p>{t('basic_integrations.min_refusion.text.line_2')}</p>
        <p>{t('basic_integrations.min_refusion.text.line_3')}</p>
        <Subtitle>{t('basic_integrations.min_refusion.text.guide_title')}</Subtitle>
        <p>{t('basic_integrations.min_refusion.text.guide_1')}</p>
        <p>{t('basic_integrations.min_refusion.text.guide_2')}</p>
        <p>{t('basic_integrations.min_refusion.text.guide_3')}</p>
        <Row className={'button-row'}>
          <Col span={6}>
            <Link
              to={
                'https://www.minrefusion.dk/?utm_source=salary&utm_medium=web_partner&utm_campaign=salaryintegration&utm_content=readmorebutton'
              }
              target={'_blank'}
            >
              <Button size="extra-extra-large">{t('basic_integrations.min_refusion.buttons.read_more')}</Button>
            </Link>
          </Col>
          <Col span={6}>
            <Link to={'/jump/companies/api-keys'} target={'_blank'}>
              <Button size="extra-extra-large">{t('basic_integrations.min_refusion.buttons.api_key')}</Button>
            </Link>
          </Col>
          <Col span={6}>
            <Link
              to={
                'https://app.minrefusion.dk/integration/install/e99f2296d28ca5c992e7d41a04ce2f09d6c37e3e8d384083713c14bfb7236cd2'
              }
              target={'_blank'}
            >
              <Button size="extra-extra-large" type="primary">
                {t('basic_integrations.min_refusion.buttons.install')}
              </Button>
            </Link>
          </Col>
        </Row>
      </Card>
    </div>
  )
}
